<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-user-plus"></i> {{ "TITLE.PERSON" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form autocomplete="off" [formGroup]="personForm">
      <label *ngIf="hasRole(ROLE_SUPERADMIN)">{{ "LABEL.PARTNER" | translate }}</label>
      <div class="input-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
        </div>
        <select *ngIf="hasRole(ROLE_SUPERADMIN)"
                class="form-control custom-width-select"
                [(ngModel)]="personReceived.partnerId"
                (change)="reloadEnterprises()"
                formControlName="partner">
          <option *ngFor="let partner of partners"
                  [ngValue]="partner.id">{{partner.name | translate}}</option>
        </select>
      </div>
      <label *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">{{ "LABEL.ENTERPRISE" | translate }}</label>
      <div class="input-group" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
        </div>
        <select *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)"
                class="form-control custom-width-select"
                [(ngModel)]="personReceived.enterpriseId"
                (change)="applyEnterpriseValidators();reloadData()"
                formControlName="enterprise">
          <option *ngFor="let enterprise of enterprises"
                  [ngValue]="enterprise.id">{{enterprise.name | translate}}</option>
        </select>
        <small *ngIf="isInvalidControl('enterprise')"
               class="text-danger">
          {{ "MESSAGE.SELECTED-COMPANY-IS-NOT-ASSOCIATED" | translate }}
        </small>
      </div>
      <div class="row" *ngIf="showMoreOptionsOfAddSearchOnDocs" [hidden]="!disableOnEditOnDocuments">
        <div class="col-md-4">
          <div class="custom-control custom-radio">
            <input type="radio"
                   id="addPersonRadio"
                   name="addSearchOpt"
                   class="custom-control-input"
                   value="3"
                   formControlName="addSearchOpt"
                   [(ngModel)]="addSearchPersonSelected"
                   (change)="onAddSearchChange()">
            <label class="custom-control-label"
                   for="addPersonRadio">{{ "LABEL.ADD-NEW" | translate }}</label>
          </div>
        </div>
        <div class="col">
          <div class="custom-control custom-radio">
            <input type="radio"
                   id="searchPersonRadio"
                   name="addSearchOpt"
                   class="custom-control-input"
                   value="4"
                   formControlName="addSearchOpt"
                   [(ngModel)]="addSearchPersonSelected"
                   (change)="onAddSearchChange()">
            <label class="custom-control-label"
                   for="searchPersonRadio">{{ "LABEL.SEARCH" | translate }}</label>
          </div>
        </div>
        <br>
        <br>
      </div>
      <div class="row">
        <div class="col" [hidden]="!disableOnEditOnDocuments">
          <label class="col-form-label">{{ "LABEL.USER-TYPE" | translate }}</label>
        </div>
        <div class="col-md-6"
             [hidden]="showMoreOptionsOfAddSearchOnDocs || !disableOnEditOnDocuments || isInvitedParticipant">
          <label for="rol" class="col-form-label">{{ "LABEL.ROLE" | translate }}</label>
        </div>
      </div>
      <div class="row" [hidden]="!disableOnEditOnDocuments">
        <div class="col-md-6">
          <div class="row" *ngFor="let participantType of participantTypes; let index=index">
            <div class="col" *ngIf="showByAddOrSearchType(participantType)">
              <div class="custom-control custom-radio">
                <input type="radio"
                       id="participantTypeRadio{{index}}"
                       name="groupRadio"
                       class="custom-control-input"
                       [attr.disabled]="disableOnEditOptSelected ? '' : null"
                       [value]="participantType.id"
                       [(ngModel)]="participantTypeSelected"
                       (change)="participantTypeChange()"
                       formControlName="groupRadio">
                <label class="custom-control-label"
                       for="participantTypeRadio{{index}}">{{'SELECT.OPTIONS.' + participantType.description | translate}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row"
               [hidden]="showMoreOptionsOfAddSearchOnDocs || !disableOnEditOnDocuments || isInvitedParticipant">
            <div class="col">
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text"><i class="fa fa-archive" aria-hidden="true"></i></div>
                </div>
                <select class="form-control uppercase {{!disableOnEditOnDocuments?'custom-input':''}}"
                        id="rol"
                        formControlName="rol"
                        [(ngModel)]="personReceived.roles"
                        [class.is-invalid]="isInvalidControl('rol')"
                        (change)="applyEnterpriseValidators()">
                  <option *ngFor="let rol of roles"
                          [ngValue]="rol.id">{{rol.nameView | translate}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12 mb-2 max-height-98" *ngIf="isObserved">
          <div class="alert badge-dark alert-dismissible fade show mb-0" role="alert">
            <div [innerHTML]="getObservation"></div>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="col" [hidden]="!disableOnEditOnDocuments">
          <label for="type" class="col-form-label">{{ "LABEL.TYPE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-user-circle" aria-hidden="true"></i></div>
            </div>
            <select class="form-control uppercase {{!disableOnEditOnDocuments?'custom-input':''}}"
                    id="type"
                    formControlName="type"
                    [(ngModel)]="personReceived.type"
                    [class.is-invalid]="isInvalidControl('type')"
                    (ngModelChange)="onChangePersonTypes()"
                    [attr.disabled]="disableOnEditOptSelected ? '' : null">
              <option *ngFor="let personType of personTypes"
                      [ngValue]="personType.id">
                {{ 'SELECT.OPTIONS.' + personType.description | translate}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6" *ngIf="!isNaturalPerson" [hidden]="!disableOnEditOnDocuments">
          <label class="col-form-label">{{ "LABEL.ENTERPRISE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
            </div>
            <input class="form-control {{isUserParticipant?'custom-input':''}}"
                   list="enterprisesList"
                   name="enterprise"
                   formControlName="enterpriseName"
                   placeholder="{{ 'MESSAGE.ENTER-RUC-OR-ENTERPRISE-NAME' | translate }}"
                   autocomplete="off"
                   [(ngModel)]="enterpriseViewnameSelected"
                   (keyup)="loadEnterprises($event)"
                   (change)="onEnterpriseChanged(enterpriseViewnameSelected)"
                   [class.is-invalid]="isInvalidControl('enterpriseName')"
                   [attr.disabled]="disableOnEditOptSelected || (hasRole(ROLE_PARTNER) && isUserParticipant) ? '' : null">
            <datalist id="enterprisesList" *ngIf="enterprisesFounded">
              <option *ngFor="let enterprise of enterprisesFounded" [ngValue]="enterprise">
                {{enterprise.documentNumber + ' - ' + enterprise.name}}
              </option>
            </datalist>
            <div *ngIf="!isNaturalPerson && (isInvitedParticipant|| isUserInvitedParticipant) && addOptSelected">
              <button type="button"
                      class="btn btn-outline-success custom-mt-24 custom-button"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="{{ 'TITLE.REGISTER-ENTERPRISE' | translate }}"
                      [disabled]="!disableOnSearchOptSelected || !disableOnEditOnDocuments"
                      (click)="openModalAddEnterprise()">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <small *ngIf="isInvalidControl('enterpriseName')"
                 class="text-danger">
            {{ "MESSAGE.ENTER-RUC-OR-ENTERPRISE-NAME" | translate }}
          </small>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" [hidden]="!disableOnEditOnDocuments">
          <label for="documentType" class="col-form-label">{{ "LABEL.DOCUMENT-TYPE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-id-card" aria-hidden="true"></i></div>
            </div>
            <select id="documentType"
                    class="form-control uppercase {{!disableOnEditOnDocuments?'custom-input':''}}"
                    formControlName="documentType"
                    [(ngModel)]="personReceived.documentType"
                    (ngModelChange)="onChangeDocType()"
                    [disabled]="!disableOnEditOnDocuments"
                    [class.is-invalid]="isInvalidControl('documentType')">
              <option *ngFor="let identifyDocument of identificationDocuments"
                      [ngValue]="identifyDocument.id">
                {{'SELECT.OPTIONS.' + identifyDocument.shortdescription | translate}}
              </option>
            </select>
          </div>
        </div>
        <div class="col" [hidden]="!disableOnEditOnDocuments">
          <label for="documentNumber" class="col-form-label">{{ "LABEL.DOCUMENT-NUMBER" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">N°</div>
            </div>
            <input type="text"
                   class="form-control uppercase {{!disableOnEditOnDocuments?'custom-input':''}}"
                   id="documentNumber"
                   formControlName="documentNumber"
                   [(ngModel)]="personReceived.documentNumber"
                   (keyup)="cleanDataAfterChanges()"
                   [class.is-invalid]="isInvalidControl('documentNumber')">
            <div class="input-group-prepend">
              <button class="btn btn-outline-success b-radius" *ngIf="disableOnSearchOptSelected"
                      [disabled]="!enableBtnSearch" [ngbTooltip]="viewBtnInfo"
                      (click)="getBy(personReceived.documentNumber)">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <small *ngIf="isInvalidControl('documentNumber')"
                 class="text-danger">
            {{getErrorMessageBy('documentNumber') | translate}}
          </small>
        </div>
        <div class="col-md-2 btn-padding-left mt-28"
             *ngIf="!disableOnSearchOptSelected || !disableOnEditOnDocuments"
             [hidden]="!disableOnEditOnDocuments">
          <button type="button"
                  class="btn btn-outline-success w-100"
                  [disabled]="disableOnSearchOptSelected || !disableOnEditOnDocuments"
                  (click)="search()">
            <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="firstName" class="col-form-label">{{ "LABEL.NAMES" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-user"></i></div>
            </div>
            <input type="text"
                   class="form-control uppercase {{!disableAfterSearch?'custom-input':''}}"
                   id="firstName"
                   formControlName="firstname"
                   [(ngModel)]="personReceived.firstname"
                   [class.is-invalid]="isInvalidControl('firstname')">
          </div>
          <small *ngIf="isInvalidControl('firstname')"
                 class="text-danger">
            {{getErrorMessageBy('firstname')}}
          </small>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="lastName" class="col-form-label">{{ "LABEL.FATHERS-LAST-NAME" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-user"></i></div>
            </div>
            <input type="text"
                   class="form-control uppercase {{!disableAfterSearch?'custom-input':''}}"
                   id="lastName"
                   formControlName="lastname"
                   [(ngModel)]="personReceived.lastname"
                   [class.is-invalid]="isInvalidControl('lastname')">
          </div>
          <small *ngIf="isInvalidControl('lastname')"
                 class="text-danger">
            {{getErrorMessageBy('lastname')}}
          </small>
        </div>
        <div class="col">
          <label for="lastName2" class="col-form-label">{{ "LABEL.MOTHERS-LAST-NAME" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-user"></i></div>
            </div>
            <input type="text"
                   class="form-control uppercase {{!disableAfterSearch?'custom-input':''}}"
                   id="lastName2"
                   formControlName="lastname2"
                   [(ngModel)]="personReceived.lastname2"
                   [class.is-invalid]="isInvalidControl('lastname2')">
          </div>
          <small *ngIf="isInvalidControl('lastname2')"
                 class="text-danger">
            {{getErrorMessageBy('lastname2')}}
          </small>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6" [hidden]="!disableOnEditOnDocuments">
          <label for="job" class="col-form-label">{{ "LABEL.COUNTRY" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-globe"></i></div>
            </div>
            <select class="form-control {{!disableOnSearchOptSelected || !disableOnEditOnDocuments?'custom-input':''}}"
                    id="country"
                    formControlName="country"
                    [(ngModel)]="personReceived.countryId"
                    [class.is-invalid]="isInvalidControl('country')">
              <option *ngFor="let country of countries"
                      [value]="country.id"> {{country.name | translate}} </option>
            </select>
          </div>
          <small *ngIf="isInvalidControl('country')"
                 class="text-danger">
            {{ "MESSAGE.NATIONALITY-IS-REQUIRED" | translate }}
          </small>
        </div>
        <div class="col-md-6" *ngIf="!isNaturalPerson"
             [hidden]="!disableOnSearchOptSelected || !disableOnEditOnDocuments">
          <label for="job" class="col-form-label">{{ "LABEL.JOB" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-briefcase"></i></div>
            </div>
            <select class="form-control uppercase {{!disableOnEditOnDocuments?'custom-input':''}}"
                    id="job"
                    formControlName="job"
                    [(ngModel)]="personReceived.jobId"
                    [class.is-invalid]="isInvalidControl('job')">
              <option *ngFor="let job of jobs" [value]="job.id"> {{job.description | translate}} </option>
            </select>
          </div>
          <small *ngIf="isInvalidControl('job')"
                 class="text-danger">
            {{ "MESSAGE.JOB-IS-REQUIRED" | translate }}
          </small>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="email" class="col-form-label">{{ "LABEL.E-MAIL" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-envelope"></i></div>
            </div>
            <input type="email"
                   class="form-control {{!disableOnSearchOptSelected || !disableOnEditOnDocuments?'custom-input':''}}"
                   id="email"
                   formControlName="email"
                   [(ngModel)]="personReceived.email"
                   [class.is-invalid]="isInvalidControl('email')">
          </div>
          <small *ngIf="isInvalidControl('email')"
                 class="text-danger">
            {{getErrorMessageBy('email')}}
          </small>
        </div>
        <div class="col-md-6">
          <label for="phone" class="col-form-label">{{ "LABEL.TELEPHONE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-phone"></i></div>
            </div>
            <input type="text"
                   class="form-control {{!disableOnSearchOptSelectedOnImput?'custom-input':''}}"
                   id="phone"
                   formControlName="phoneNumber"
                   [(ngModel)]="personReceived.cellphone"
                   [class.is-invalid]="isInvalidControl('phoneNumber')">
          </div>
          <small *ngIf="isInvalidControl('phoneNumber')"
                 class="text-danger">
            {{getErrorMessageBy('phoneNumber')}}
          </small>
        </div>
      </div>
      <div class="row"
           [hidden]="showMoreOptionsOfAddSearchOnDocs || !disableOnEditOnDocuments || isInvitedParticipant">
        <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-checkbox-document-images">
          <input type="checkbox"
                 class="custom-control-input"
                 id="twoFactorAuthenticationChecked"
                 formControlName="twoFactorAuthentication"
                 [(ngModel)]="twoFactorAuthentication"
                 (ngModelChange)="changeStatus6($event)">
          <label class="custom-control-label"
                 for="twoFactorAuthenticationChecked">{{ "LABEL.ADD-TWO-FACTOR-AUTHENTICATION" | translate }}</label>
        </div>
        <!--        <br>-->
      </div>
      <div class="row"
           [hidden]="showMoreOptionsOfAddSearchOnDocs || !disableOnEditOnDocuments || isInvitedParticipant">
        <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-checkbox-document-images">
          <input type="checkbox"
                 class="custom-control-input"
                 id="changePasswordTemporaryChecked"
                 formControlName="changePasswordTemporary"
                 [(ngModel)]="changePasswordTemporary"
                 (ngModelChange)="changeStatus8($event)">
          <label class="custom-control-label"
                 for="changePasswordTemporaryChecked">{{ "Programar tiempo en el que se solicitará el cambio de contraseña." }}</label>
        </div>
        <br>
      </div>
      <div *ngIf="changePasswordTemporary" class="mt-2">
        <div class="row col-md-8">
          <div class="col">
            <select class="form-control form-select" formControlName="dateType">
              <option *ngFor="let dateType of dateTypes" [ngValue]="dateType">
                {{ 'SELECT.OPTIONS.' + dateType.name | translate }}
            </select>
          </div>
          <div class="col">
            <input class="form-control" placeholder="Ingrese el tiempo en números" type="number"
                   formControlName="timeOnNumber" oninput="validateNumber(event)" min="1"
                   [class.is-invalid]="isInvalidControl('timeOnNumber')">
            <small *ngIf="isInvalidControl('timeOnNumber')"
                   class="text-danger">
              {{getErrorMessageBy('timeOnNumber')}}
            </small>
          </div>
        </div>
      </div>
      <div class="row"
           [hidden]="showMoreOptionsOfAddSearchOnDocs || !disableOnEditOnDocuments || isInvitedParticipant">
        <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-checkbox-document-images">
          <input type="checkbox"
                 class="custom-control-input"
                 id="passwordLevelChecked"
                 formControlName="passwordSecurityLevel"
                 [(ngModel)]="passwordSecurityLevel"
                 (ngModelChange)="changeStatus9($event)">
          <label class="custom-control-label"
                 for="passwordLevelChecked">{{ "Agregar nivel de complejidad a la contraseña" }}</label>
        </div>
        <!--        <br>-->
      </div>
      <div *ngIf="this.passwordSecurityLevel">
        <div class="col">
          <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-checkbox-document-images">
            <input type="checkbox"
                   class="custom-control-input"
                   id="passwordLevelHighChecked"
                   formControlName="passwordHighLevel"
                   [value]="1"
                   [(ngModel)]="passwordLevelHighChecked"
                   [checked]="passwordLevelHighChecked"
                   (change)="changeStatus10($event , 1)">
            <label class="custom-control-label"
                   for="passwordLevelHighChecked">{{ "Nivel de seguridad Alto" }}</label>
          </div>
        </div>
        <div class="col">
          <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-checkbox-document-images">
            <input type="checkbox"
                   class="custom-control-input"
                   id="passwordLevelMedioChecked"
                   formControlName="passwordMedioLevel"
                   [(ngModel)]="passwordLevelMedioChecked"
                   [value]="2"
                   [checked]="passwordLevelMedioChecked" (change)="changeStatus11($event, 2)">
            <label class="custom-control-label"
                   for="passwordLevelMedioChecked">{{ "Nivel de seguridad Medio" }}</label>
          </div>
        </div>
        <br>
      </div>

      <div class="row" *ngIf="hasRoleSimple">
        <div class="col">
          <label for="serialnumber" class="col-form-label">{{ "LABEL.SERIAL-NUMBER" | translate }}</label>
          <div class="input-group">
            <div class="input-group-append">
              <div class="input-group-text"><i class="fas fa-tag"></i></div>
            </div>
            <input type="text"
                   class="form-control {{!disableOnSearchOptSelected || !disableOnEditOnDocuments?'custom-input':''}}"
                   id="serialnumber"
                   formControlName="serialnumber"
                   [(ngModel)]="personReceived.certificateSerialNumber">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-7">
          <label for="job" class="col-form-label">{{ "LABEL.RUBRIC" | translate }}</label>
          <div class="custom-file content-file">
            <input type="file"
                   [disabled]="!disableOnSearchOptionSelected"
                   class="custom-file-input"
                   accept="image/jpeg, image/png"
                   alife-file-to-base64
                   id="customRubricFile"
                   (change)="readSelectedRubric($event)"
                   (onFileChanged)="changeStatus2($event)"
                   [class.is-invalid]="isInvalidControl('rubricFilename2Show')">
            <small *ngIf="isInvalidControl('rubricFilename2Show')"
                   class="text-danger">
              {{ "MESSAGE.SELECT-RUBRIC" | translate }}
            </small>
            <div class="custom-file-label">
              <label for="customRubricFile">
                {{personForm.get('rubricFilename2Show').value ? personForm.get('rubricFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <label for="job" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
          <div>
            <img [src]="defaultRubricSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
          </div>
        </div>
      </div>
      <div class="form-group mb-0">
        <label for="labelSelect">{{ "LABEL.TAGS" | translate }}</label>
        <select2 id="labelSelect"
                 multiple="multiple"
                 formControlName="label"
                 [data]="selectableLabels"
                 [(ngModel)]="personReceived.labelIds">
        </select2>
      </div>
      <div class="row" [hidden]="isCloudSignature || isElectronicSignature">
        <div class="custom-control custom-checkbox my-1 mr-sm-2 custom-checkbox-document-images">
          <input type="checkbox"
                 [attr.disabled]="!disableOnSearchOptionSelected ? '' : null"
                 class="custom-control-input"
                 id="addImgDocumentChecked"
                 formControlName="addDocumentImages"
                 [(ngModel)]="checkedAddImgDocument"
                 (ngModelChange)="onAddDocumentImages($event)">
          <label class="custom-control-label"
                 for="addImgDocumentChecked">{{ "LABEL.ADD-IMAGES-OF-IDENTITY-DOCUMENT" | translate }}</label>
        </div>
      </div>
      <div class="row" [hidden]="!addDocumentImages">
        <div class="col-md-7">
          <label for="job"
                 class="col-form-label">{{ "LABEL.IMAGE-FRONT-OF-THE-IDENTITY-DOCUMENT" | translate }}</label>
          <div class="custom-file content-file">
            <input type="file"
                   [disabled]="!disableOnSearchOptSelectedOnImput"
                   class="custom-file-input"
                   accept="image/jpeg, image/png"
                   alife-file-to-base64
                   id="obverseDNI"
                   (change)="readSelectedDocumentFront($event)"
                   (onFileChanged)="changeStatus3($event)"
                   [class.is-invalid]="isInvalidControl('documentFrontFilename2Show')">
            <small *ngIf="isInvalidControl('documentFrontFilename2Show')"
                   class="text-danger">
              {{ "MESSAGE.SELECT-IMAGE-OF-FRONT-OF-IDENTITY-DOCUMENT" | translate }}
            </small>
            <div class="custom-file-label">
              <label for="customRubricFile">
                {{personForm.get('documentFrontFilename2Show').value ? personForm.get('documentFrontFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <label for="job" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
          <div>
            <img [src]="defaultDocumentFrontSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
          </div>
        </div>
      </div>
      <div class="row" [hidden]="!addDocumentImages">
        <div class="col-md-7">
          <label for="job"
                 class="col-form-label">{{ "LABEL.IMAGE-BACK-OF-THE-IDENTITY-DOCUMENT" | translate }}</label>
          <div class="custom-file content-file">
            <input type="file"
                   [disabled]="!disableOnSearchOptSelectedOnImput"
                   class="custom-file-input"
                   accept="image/jpeg, image/png"
                   alife-file-to-base64
                   id="backDNI"
                   (change)="readSelectedBackDNI($event)"
                   (onFileChanged)="changeStatus4($event)"
                   [class.is-invalid]="isInvalidControl('documentRearFilename2Show')">
            <small *ngIf="isInvalidControl('documentRearFilename2Show')"
                   class="text-danger">
              {{ "MESSAGE.SELECT-IMAGE-OF-BACK-OF-IDENTITY-DOCUMENT" | translate }}
            </small>
            <div class="custom-file-label">
              <label for="customRubricFile">
                {{personForm.get('documentRearFilename2Show').value ? personForm.get('documentRearFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <label for="job" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
          <div>
            <img [src]="defaultDocumentRearSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
          </div>
        </div>
      </div>
      <div class="row" [hidden]="!addDocumentImages">
        <div class="col-md-7">
          <label for="file" class="col-form-label">{{ "LABEL.POWER-VALIDITY" | translate }}</label>
          <div class="custom-file content-file">
            <input type="file"
                   class="custom-file-input"
                   accept="application/pdf"
                   id="file"
                   alife-file-to-base64
                   (change)="readSelectedPWfile($event)"
                   (onFileChanged)="changeStatus1($event)"
                   [class.is-invalid]="isInvalidControl('filename2Show')">
            <small *ngIf="isInvalidControl('filename2Show')"
                   class="text-danger">
              {{ "MESSAGE.FILE-ARE-REQUIRED" | translate }}
            </small>
            <div class="custom-file-label">
              <label for="customRubricFile">
                {{personForm.get('filename2Show').value ? personForm.get('filename2Show').value : hasPowerValidity2}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <label for="job" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
          <div>
            <button type="button"
                    [disabled]="!hasPowerValidity1"
                    class="btn btn-outline-success"
                    (click)="openModalPdfViewer(POWER_VALIDITY)">
              <i class="fa fa-eye fz-24 custom-ml-12"></i> {{ "BUTTON.PREVIEW" | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="row" [hidden]="!addDocumentImages">
        <div class="col-md-7">
          <label for="file" class="col-form-label">{{ "LABEL.RUC-FILE" | translate }}</label>
          <div class="custom-file content-file">
            <input type="file"
                   class="custom-file-input"
                   accept="application/pdf"
                   id="rucFile"
                   alife-file-to-base64
                   (change)="readSelectedRUCfile($event)"
                   (onFileChanged)="changeStatus7($event)"
                   [class.is-invalid]="isInvalidControl('rucFilename2Show')">
            <small *ngIf="isInvalidControl('rucFilename2Show')"
                   class="text-danger">
              {{ "MESSAGE.FILE-ARE-REQUIRED" | translate }}
            </small>
            <div class="custom-file-label">
              <label for="customRubricFile">
                {{personForm.get('rucFilename2Show').value ? personForm.get('rucFilename2Show').value : hasRUCFile2}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <label for="job" class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
          <div>
            <button type="button"
                    [disabled]="!hasRUCFile1"
                    class="btn btn-outline-success"
                    (click)="openModalPdfViewer(RUC_FILE)">
              <i class="fa fa-eye fz-24 custom-ml-12"></i> {{ "BUTTON.PREVIEW" | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col" *ngIf="!isNewPerson && !showMoreOptionsOfAddSearchOnDocs">
          <label for="state" class="col-form-label">{{ "LABEL.STATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="{{ isActive ? 'input-group-text': 'input-group-text-danger' }}"><i
                class="{{ isActive ? 'fas fa-toggle-on': 'fas fa-toggle-off' }}"></i></div>
            </div>
            <select class="form-control uppercase {{!disableOnEditOnDocuments?'custom-input':''}}"
                    id="state"
                    formControlName="status"
                    [(ngModel)]="personReceived.active"
                    [class.is-invalid]="isInvalidControl('status')">
              <option [value]="1">{{ "LABEL.ACTIVE" | translate }}</option>
              <option [value]="0">{{ "LABEL.INACTIVE" | translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle" aria-hidden="true"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
<ng-template #viewBtnInfo>{{ "MESSAGE.SEARCH-PERSON-DATA-RENIEC" | translate }}</ng-template>
